<template>
  <div class="container" @click="hideSearchType">
    <div class="filter-con">
      <div class="search">
        <div class="option">
          <span @click.stop="searchTypeOpen">{{ searchType == "1" ? "搜标题" : "搜标签" }}</span>
          <div v-if="selectVisble" class="items">
            <div :class="[searchType == '1' ? 'active' : '']" @click="onSearchTypeChange('1')">搜标题</div>
            <div :class="[searchType == '2' ? 'active' : '']" @click="onSearchTypeChange('2')">搜标签</div>
          </div>
        </div>
        <div class="split">
          <div class="line"></div>
        </div>
        <div class="ipt">
          <el-input
            v-model="searchTxt"
            placeholder="搜索"
            enterkeyhint="search"
            @focus="onSearchForcus"
            @keyup.enter.native="searchData"
            @clear="searchData"
            clearable
          ></el-input>
        </div>

        <!-- <div class="btn-clear" @click="clearSearchTxt" v-if="searchTxt && tagId == null"></div> -->
        <!-- <el-input class="ipt" placeholder="搜索" v-model="searchTxt" clearable ></el-input> -->
      </div>
      <div class="tag-con">
        <div
          :class="['tag', tag.id == tagId ? 'active' : '', tag.selectId ? 'select' : '']"
          :key="tag.id"
          v-for="tag in tagList"
        >
          <span class="name" @click="onTopTagClick(tag)">{{ tag.selectName || tag.tagName }}</span>
        </div>
      </div>
      <div class="tag-sub" v-if="showFilter">
        <div class="tag-info">
          <div class="list">
            <div
              :class="['item', tag.selected ? 'active' : '', tag.checked ? 'active' : 'unactive']"
              @click="onTagClick(tag)"
              :key="tag.id"
              v-for="tag in subCate.childrens.filter(item => item.childrens == null)"
            >
              {{ tag.tagName }}
            </div>
            <div class="items" :key="tag.id" v-for="tag in subCate.childrens.filter(item => item.childrens != null)">
              <div class="name">{{ tag.tagName }}</div>
              <div class="stags">
                <div
                  :class="['item', stag.selected ? 'active' : '', stag.checked ? 'active' : 'unactive']"
                  @click="onTagClick(stag)"
                  :key="stag.id"
                  v-for="stag in tag.childrens || []"
                >
                  {{ stag.tagName }}
                </div>
              </div>
            </div>
          </div>
          <div class="btn-con">
            <div @click="onFilterReset">重置</div>
            <div @click="onFilterClick" class="ok">确定</div>
          </div>
        </div>
      </div>
      <div class="select-tags" v-if="selectTags.length > 0">
        <span :key="tag.id" v-for="tag in selectTags">
          {{ tag.tagName }}
          <span @click="onSelectTagRemove(tag)" class="del"></span>
        </span>
      </div>
    </div>
    <div class="list-con">
      <div
        class="list"
        v-infinite-scroll="loadMore"
        infinite-scroll-immediate="false"
        infinite-scroll-disabled="noMore"
        infinite-scroll-delay="100"
        infinite-scroll-distance="50"
      >
        <div class="item" :key="item.id" v-for="item in list">
          <div class="img">
            <el-image fit="cover" :src="item.url" :preview-src-list="[item.urlSource]"></el-image>
          </div>
          <div class="info">
            <div class="title">{{ item.image.name }}</div>
            <!-- <div class="tags" v-if="item.tagString">{{ item.tagString }}</div> -->
            <div class="date">创建于 {{ item.createTime }}</div>
          </div>
        </div>
      </div>
      <div class="boot-txt" v-if="loading">加载中...</div>
      <div class="boot-txt" v-if="noMore">没有更多了</div>
      <div class="mask" v-if="showFilter"></div>
    </div>
  </div>
</template>

<script>
import { getGalleryTagList, getGalleryList } from "../../api/gallery";
export default {
  name: "Gallery",
  data() {
    return {
      searchTxt: "",
      searchType: "1",
      selectVisble: false,
      list: [],
      tagList: [],
      allTagList: [],
      tagId: null,
      showFilter: false,
      pageNum: 1,
      pageSize: 10,
      total: -1,
      loading: false,
    };
  },
  created() {
    document.title = "应用图库";
  },
  mounted() {
    this.getTagList();
  },
  computed: {
    subCate() {
      return this.tagList.find(tag => tag.id == this.tagId);
    },

    noMore() {
      return this.list.length >= this.total && this.total > -1;
    },
    disabled() {
      return this.loading || this.noMore;
    },
    selectTags() {
      let result = [];

      this.tagList.forEach(tag => {
        tag.childrens?.forEach(obj => {
          if (obj.childrens == null && obj.selected) {
            result.push(obj);
          } else {
            obj.childrens?.forEach(item => {
              if (item.selected) {
                result.push(item);
              }
            });
          }
        });
      });

      return result;
    },
  },
  methods: {
    onSearchTypeChange(type) {
      this.searchType = type;
      this.hideSearchType();
    },
    hideSearchType() {
      this.selectVisble = false;
    },
    searchTypeOpen() {
      this.selectVisble = true;
    },
    onSearchForcus() {
      this.showFilter = false;
      this.tagId = null;
    },
    clearSearchTxt() {
      this.searchTxt = "";
      this.pageNum = 1;
      this.getList();
    },
    onTagClick(tag) {
      // tag.childrens
      let checked = true;
      if (tag.checked) {
        checked = false;
      }
      tag.checked = checked;
    },
    onSelectTagRemove(tag) {
      console.log(tag, "sdkfjsdk");

      let removeSelect = list => {
        list?.forEach(item => {
          if (item.id == tag.id) {
            item.selected = false;
          }
          removeSelect(item.childrens);
        });
      };
      removeSelect(this.tagList);

      this.onFilterClick();
    },
    searchData() {
      this.pageNum = 1;
      this.getList();
    },
    getSelected(tag) {
      let result = "";
      if (tag.checked) {
        result = "active";
      } else {
        if (tag.selected) {
          result = "active";
        }
      }
      return result;
    },
    loadMore() {
      this.pageNum += 1;
      this.getList();
    },
    onFilterReset() {
      let curTag = this.tagList.find(tag => tag.id == this.tagId);

      curTag.childrens.forEach(tag => {
        if (tag.id == curTag.selectId) {
          tag.selected = false;
        }
        tag.childrens?.forEach(item => {
          if (item.id == curTag.selectId) {
            item.selected = false;
          }
        });
      });
      curTag.selectList = [];
      this.tagId = null;
      this.showFilter = false;
      this.getList();
    },
    onFilterClick() {
      this.pageNum = 1;

      let curTag = this.tagList.find(tag => tag.id == this.tagId);

      if (curTag) {
        curTag.childrens.forEach(tag => {
          if (tag.childrens == null) {
            tag.selected = tag.checked;
          } else {
            tag.childrens.forEach(item => {
              item.selected = item.checked;
            });
          }
        });
      }

      this.tagId = null;
      this.showFilter = false;
      this.getList();
    },
    onTopTagClick(tag) {
      if (this.tagId == tag.id) {
        this.showFilter = !this.showFilter;
        this.tagId = null;
      } else {
        this.tagId = tag.id;
        this.showFilter = true;
        // //清掉没点确定的样式
        this.tagList.forEach(tag => {
          tag.childrens.forEach(item => {
            if (item.childrens == null) {
              if (item.checked != item.selected) {
                item.checked = item.selected;
              }
            } else {
              item.childrens.forEach(sitem => {
                if (sitem.checked != sitem.selected) {
                  sitem.checked = sitem.selected;
                }
              });
            }
          });
        });
      }
    },

    getTagList() {
      getGalleryTagList({ tagName: "" })
        .then(res => {
          if (res.code == 200) {
            let tagList = res.data.childrens;

            let initTag = list => {
              list?.forEach(item => {
                item.selected = false;
                item.checked = false;
                initTag(item.childrens);
              });
            };
            initTag(tagList);

            //处理数据
            let allTagList = [];
            tagList.forEach(tag => {
              let hasChilders = tag.childrens.filter(item => item.childrens == null);
              if (hasChilders.length != tag.childrens.length) {
                tag.childrens.forEach(item => {
                  if (item.childrens == null) {
                    let titem = { ...item };
                    item.childrens = [titem];
                    allTagList.push(item);
                  }
                });
              } else {
                allTagList.push(tag);
              }
            });
            this.allTagList = allTagList;
            console.log(allTagList.length, "allTagList");
            this.tagList = tagList;
            // this.tagListOrigin = [...tagList];
          }
        })
        .finally(_ => {
          this.getList();
        });
    },

    getList() {
      this.loading = true;
      if (this.pageNum == 1) {
        this.list = [];
      }

      let selectTagList = [];
      this.tagList.forEach(tag => {
        tag.childrens.forEach(item => {
          if (item.childrens == null) {
            if (item.selected) {
              selectTagList.push(item);
            }
          } else {
            item.childrens.forEach(sitem => {
              if (sitem.selected) {
                selectTagList.push(sitem);
              }
            });
          }
        });
      });

      let tagIds = selectTagList.map(item => item.id);
      // let selectList = this.tagList
      //   .filter(item => item.selectList.length > 0)
      //   .forEach(item => {
      //     let ids = item.selectList.map(tag => tag.id);
      //     tagIds = tagIds.concat(ids);
      //   });
      let data = {
        tagIds: tagIds,
        name: "",
        tagSearchValue: "",
        startTime: "",
        endTime: "",
        rootModuleId: "2",
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: 1,
        type: 0
      };
      if (this.searchType === "1") {
        data.name = this.searchTxt;
      } else {
        data.tagSearchValue = this.searchTxt;
      }
      getGalleryList(data)
        .then(res => {
          if (res.code == 200) {
            let records = res.data.records;
            records.forEach(item => {
              item.createTime = item.createTime.replace("T", " ").slice(0, 16);
              item.tagString = item.tags.map(obj => obj.tagName).join(",");
            });
            this.total = res.data.total;
            this.list = this.list.concat(records);
          }
        })
        .finally(_ => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
body {
  background-color: #f5f5f5;
  .el-select-dropdown__item {
    font-size: 0.28rem !important;
  }
}
.container {
  padding-top: 1.84rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 0;

  & > .filter-con {
    flex: 0 0 1.84rem;
    position: relative;
    z-index: 888;
    background-color: #fff;
    & > .search {
      padding: 0.16rem 0.24rem;
      position: relative;
      display: flex;
      align-items: center;

      background-color: #fff;
      & > .option {
        flex: 0 0 1.4rem;
        height: 0.64rem;
        line-height: 0.64rem;
        text-align: center;
        background: rgba(0, 0, 0, 0.04) url("~@/assets/imgs/icon_arrow_down@2x.png") no-repeat right center / 0.32rem
          0.32rem;
        padding-right: 0.2rem;
        font-size: 0.28rem;
        position: relative;
        & > .items {
          position: absolute;
          left: 0;
          z-index: 999;
          top: 0.64rem;
          background-color: #fff;
          border-radius: 0.08rem;
          width: 100%;
          box-shadow: 0 0 0.2rem #ccc;
          & > div {
            font-size: 0.28rem;
            &.active {
              color: #e60027;
            }
          }
        }

        // &/deep/ .el-input__inner {
        //   border-radius: 0.08rem 0 0 0.08rem !important;

        //   font-size: 0.28rem;
        // }
        // &/deep/ .el-scrollbar .el-scrollbar__bar {
        //   opacity: 1 !important;
        // }
      }
      & > .split {
        height: 0.64rem;
        width: 0.02rem;
        background: rgba(0, 0, 0, 0.04);
        padding: 0.14rem 0;
        box-sizing: border-box;
        & > .line {
          height: 0.36rem;
          width: 0;
          border-left: 1px solid #e5e6eb;
        }
      }
      & > .ipt {
        flex: 1;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 0 0.08rem 0.08rem 0 !important;
        &/deep/ .el-input__inner {
          background: url("~@/assets/imgs/search.png") no-repeat 0.18rem center / 0.32rem auto;
          padding-left: 0.58rem;
          font-size: 0.28rem;
        }
      }

      & /deep/ .el-input__inner {
        border: 0;
        font-size: 0.24rem;
        height: 0.64rem;
        line-height: 0.64rem;

        position: relative;
      }
      & /deep/ .el-input__icon {
        line-height: 0.64rem;
      }
      // & > input {
      //   padding-left: 0.64rem;
      //   height: 0.64rem;
      //   line-height: 0.64rem;
      //   outline: none;
      //   display: block;
      //   width: 100%;
      //   box-sizing: border-box;
      //   border: 0;
      //   border-radius: 0.08rem;
      //   background: url("~@/assets/imgs/search.png") no-repeat 0.18rem center /
      //     0.4rem auto;
      //   background-color: rgba(0, 0, 0, 0.04);
      //   font-size: 0.24rem;
      // }
      // & > .btn-clear {
      //   position: absolute;
      //   width: 0.32rem;
      //   height: 0.32rem;
      //   margin-top: -0.16rem;
      //   top: 50%;
      //   right: 0.4rem;
      //   border-radius: 50%;
      //   background: url("~@/assets/imgs/icon_gray_close@2x.png") no-repeat
      //     center center / 100% auto;
      // }
    }
    & > .tag-con {
      display: flex;
      align-items: center;
      overflow-x: auto;
      padding: 0.24rem 0.32rem;
      position: relative;
      & > .tag {
        flex: 0 0 auto;
        margin-right: 0.32rem;
        border: 0.01rem solid #ccc;
        padding: 0.04rem;
        border-radius: 0.24rem;
        padding-left: 0.24rem;
        & > .name {
          display: inline-block;
          padding-right: 0.36rem;
          background: url("~@/assets/imgs/icon_arrow_down@2x.png") no-repeat right center / 0.32rem 0.32rem;
        }
      }

      & > .active {
        & > .name {
          color: #e60027;
          padding-right: 0.36rem;
          background: url("~@/assets/imgs/icon_arrow_up@2x.png") no-repeat right center / 0.32rem 0.32rem;
        }
      }
      & > .select {
        & > .name {
          color: #e60027;
        }
      }
      &::-webkit-scrollbar {
        display: none;
      }
    }
    & > .tag-sub {
      position: relative;
      & > .tag-info {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        background-color: #fff;
        z-index: 999;
        & > .list {
          padding: 0 0.24rem;
          font-size: 0.26rem;
          height: 7rem;
          overflow-y: auto;
          & > .items {
            padding-top: 0.2rem;
            & > .name {
              font-size: 0.26rem;
              padding-bottom: 0.08rem;
              color: rgba(0, 0, 0, 0.85);
              font-weight: bold;
              padding-left: 0.08rem;
            }
            // & > .stags {
            // }
          }
          & .item {
            display: inline-block;
            height: 0.64rem;
            line-height: 0.64rem;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.04);
            color: rgba(0, 0, 0, 0.6);
            margin: 0.08rem;
            padding: 0 0.27rem;
            border-radius: 0.08rem;
            box-sizing: border-box;
            font-size: 0.26rem;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
            &.active {
              background-color: #fff1f0;
              color: #e60027;
            }

            &.unactive {
              background-color: rgba(0, 0, 0, 0.04);
              color: rgba(0, 0, 0, 0.6);
            }
            // padding-top: 0.08rem;
            // padding-right: -0.16rem;
          }
        }
        // & > .cate {
        //   padding: 0.24rem 0.32rem;
        //   & > .name {
        //     font-size: 0.28rem;
        //     color: rgba(0, 0, 0, 0.85);
        //     line-height: 0.4rem;
        //     font-weight: 500;
        //   }
        //   & > .tags {
        //     padding-top: 0.08rem;
        //     padding-right: -0.16rem;
        //     & > .tag {
        //       display: inline-block;
        //       margin: 0 0.14rem 0.14rem 0;
        //       width: 1.6rem;
        //       height: 0.64rem;
        //       background-color: rgba(0, 0, 0, 0.04);
        //       font-size: 0.24rem;
        //       color: rgba(0, 0, 0, 0.6);
        //       line-height: 0.64rem;
        //       text-align: center;
        //       border-radius: 0.08rem;
        //       overflow: hidden;
        //       text-overflow: ellipsis;
        //       white-space: nowrap;
        //       padding: 0 0.12rem;
        //       box-sizing: border-box;
        //       &.active {
        //         color: #e60027;
        //         background-color: #fff1f0;
        //       }
        //       &:nth-child(4n) {
        //         margin-right: 0;
        //       }
        //     }
        //   }
        // }
        & > .btn-con {
          display: flex;
          align-items: center;
          padding: 0.2rem;
          & > div {
            flex: 1;
            height: 0.8rem;
            line-height: 0.8rem;
            text-align: center;
            font-size: 0.3rem;
            font-weight: bold;
            border-radius: 0.08rem;
            border: 0.02rem solid #e5e6eb;
            margin: 0.12rem;
            &.ok {
              background-color: #e60027;
              color: #fff;
            }
          }
        }
      }
    }
    & > .select-tags {
      padding: 0.24rem;
      padding-bottom: 0;
      & > span {
        display: inline-block;
        padding: 0 0.24rem;
        line-height: 0.4rem;
        height: 0.4rem;
        background-color: #f5f5f5;
        color: rgba(0, 0, 0, 0.6);
        font-size: 0.24rem;
        margin: 0 0.14rem 0.14rem 0;
        position: relative;
        & > .del {
          position: absolute;
          width: 0.32rem;
          height: 0.32rem;
          background: url("~@/assets/imgs/icon_gray_close@2x.png") no-repeat center center / 100% auto;
          top: -0.16rem;
          right: -0.16rem;
          cursor: pointer;
        }
      }
    }
  }
  & > .list-con {
    flex: 1;
    height: 10px;
    overflow-y: auto;
    position: relative;
    box-sizing: border-box;
    background-color: #f5f5f5;
    padding: 0 0.08rem;
    padding-top: 0.14rem;
    & > .list {
      display: flex;
      align-items: stretch;
      flex-wrap: wrap;

      & > .item {
        flex: 0 0 3.5rem;
        width: 3.5rem;
        margin: 0.08rem;
        background-color: #fff;
        border-radius: 0.08rem;
        & > .img {
          width: 3.5rem;
          height: 1.98rem;
          border-radius: 0.08rem;
          overflow: hidden;
          background-position: center center;
          background-size: 100% auto;
          background-repeat: no-repeat;
          & /deep/ img {
            width: 3.5rem;
            height: 1.98rem;
          }
        }
        & > .info {
          padding: 0.24rem 0.16rem;
          // height: 1.28rem;
          font-size: 0.28rem;
          & > .title {
            color: rgba(0, 0, 0, 0.85);
            font-weight: 500;
            line-height: 0.33rem;
            word-break: break-all;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: 0.4rem;
          }
          & > .tags,
          .date {
            color: rgba(0, 0, 0, 0.45);
            line-height: 0.28rem;
            padding-top: 0.16rem;
            font-size: 0.24rem;
          }
          & > .tags {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    & .boot-txt {
      text-align: center;
      color: rgba(0, 0, 0, 0.45);
      font-size: 0.24rem;
      padding: 0.24rem 0;
    }
    & > .mask {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      top: 1.84rem;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 666;
    }
  }
}
</style>
